import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { parseAgentTabRoute, TAB_WAITING_PAGE } from '../routing/browser-tab-routes';
import { AgentAccessService } from '../services/agent-access.service';

/** Roles without an events home are sent to the waiting page. Escalation may open events to view site status. */
export const eventsDashboardGuard: CanActivateFn = (_route, state) => {
  const access = inject(AgentAccessService);
  if (access.canOpenEventsDashboard()) {
    return true;
  }

  const tabId = parseAgentTabRoute(state.url)?.tabId ?? 't1';
  return inject(Router).createUrlTree([`/${tabId}`, TAB_WAITING_PAGE]);
};
